// @flow weak

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

const MaybeRedirectOnMount = createReactClass({
  displayName: 'MaybeRedirectOnMount',

  propTypes: {
    Component: PropTypes.func.isRequired,
    redirectUrl: PropTypes.string.isRequired,
    shouldRedirect: PropTypes.bool.isRequired,
    onRedirect: PropTypes.func.isRequired,
  },

  UNSAFE_componentWillMount() {
    if (this.props.shouldRedirect) {
      this.props.onRedirect(this.props.redirectUrl);
    }
  },

  render() {
    const { Component, shouldRedirect } = this.props;
    const ownProps = [
      'Component',
      'redirectUrl',
      'shouldRedirect',
      'onRedirect',
    ];
    return shouldRedirect ? null : (
      <Component {..._.omit(this.props, ownProps)} />
    );
  },
});

export default MaybeRedirectOnMount;
